import {theme} from "../../theme";
// import {useState} from "react";
// import ModalTemplate from "../general/ModalTemplate";
// import {Button, Link, Table, TableBody, TableCell, TableRow, Typography} from "@mui/material";
// import {useTranslation} from "react-i18next";
import {Recommendation} from "../../pages/Results";

export default function SuggestedItem(props: { item: Recommendation; index: number }) {
  // const { t } = useTranslation();
  // i18n.language
  // const [showDetail, setShowDetail] = useState(false);
  // function setModalVisible() {
  //   setShowDetail(true);
  // }
  // function hideModal() {
  //   setShowDetail(false);
  // }

  function openOnlineShop(url: string | null | undefined): void {
    if (!url) {
      console.error("URL is required to open a new tab.");
      return;
    }
    // Open the URL in a new tab
    window.open(url, '_blank');
  }


  const item = props.item;
  const article = item.article_informaton_i18n[0];
  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", height: "100%", cursor: "pointer", position: "relative" }}
        onClick={() =>openOnlineShop(article.shop_url)}
      >
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          background: "black",
          color: "white",
          padding: "4px 8px",
          borderRadius: "0 0 4px 0",
          fontSize: "0.9em",
          fontWeight: "bold"
        }}>
          {props.index + 1}.
        </div>
        <p style={{ fontSize: theme.typography.body1.fontSize, marginTop: "24px" }}>
          <b>{article.name?.toUpperCase() ?? '-'}</b>
        </p>
        <img src={article.images[0]} style={{ width: "100%", margin: "auto" }} alt="Produktbild" />
        <p style={{ color: theme.palette.secondary.main, marginTop: "auto" }}>{article.size == "-/-" ? "" : article.size}</p>
      </div>
    </>
  );
}
